<template>
  <div>
    <p v-if="saveHint" class="mb-2">
      Klicke auf die {{$tc('files', files.length)}} um diese auf deinem Gerät zu speichern.
    </p>
    <p v-if="description" class="mb-2">
      <strong class="font-weight-medium">Beschreibung:</strong> {{description}}
    </p>
    <component
      :is="file.href ? 'a' : 'div'"
      v-for="(file, i) in files_wHref"
      :key="i"
      class="d-flex align-center small"
      :class="i + 1 === files.length ? 'mb-0' : 'mb-2'"
      :href="file.href ? file.href : null"
      :download="file.href ? file.name : null"
      :target="file.href ? downloadTarget : null"
      @click="file.href ? _deleteBlob(i) : null"
    >
      <i :class="_fileIcon(file)" class="file-type mr-4"></i>
      <div class="text-truncate" :title="file.name">
        {{file.name}}
        <span class="text-truncate d-block">{{_fileSize(file.size)}}</span>
      </div>
    </component>
    <small v-if="files.length > 1 && sum" class="d-block mt-2">
      Gesamt: {{_fileSize(sum)}}
    </small>
  </div>
</template>

<script>
  import getClassNameForExtension from 'font-awesome-filetypes';
  import {downloadSupported, formatFileSize} from '../../assets/js/utils';


  export default {
    name: 'PeerFiles',

    props: {
      files: {
        type: Array,
        default: () => []
      },
      description: {
        type: String,
        default: ''
      },
      // optional, only needed for file blobs
      notificationId: {
        type: String,
        default: ''
      }
    },

    data: () => ({
      downloadTarget: downloadSupported ? '_self' : '_blank'
    }),

    computed: {
      files_wHref() {
        return this.files.map((file) => {
          return {
            ...file,
            href: file.blob ? URL.createObjectURL(file.blob) : undefined
          };
        });
      },

      saveHint() {
        return !!this.files_wHref.filter((file) => !!file.href).length;
      },

      sum() {
        const sum = this.files.map(({size}) => size).reduce((a, b) => a + b, 0);
        return typeof sum !== 'string' ? sum : 0;
      }
    },

    methods: {
      _fileIcon(file) {
        const {name} = file;
        const extension = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
        const className = 'fas ' + getClassNameForExtension(extension);

        return className;
      },

      _fileSize(size) {
        return typeof size === 'string' ? size : formatFileSize(size);
      },

      _deleteBlob(index) {
        const {notificationId, $store} = this;
        if (!notificationId) {
          return;
        }

        const notification = $store.getters['share/getNotification'](notificationId);
        const file = notification?.data?.files?.[index];
        if (file) {
          delete file.blob;
          $store.commit('share/updateNotification', notification);

          // XXX: Fix prop here.
          // eslint-disable-next-line vue/no-mutating-props
          this.files.splice(index, 1, file);
        }
      }
    }
  };
</script>

<style scoped>
  .small {
    font-size: 80%;
  }
</style>
